// Lightweight hook to track navigator.onLine
import { useEffect, useState, useSyncExternalStore } from "react";
import { listDrafts, onChange, pendingCount, syncDrafts } from "./offline";

export function useOnline() {
  const [online, setOnline] = useState(typeof navigator !== "undefined" ? navigator.onLine : true);
  useEffect(() => {
    const up = () => setOnline(true);
    const down = () => setOnline(false);
    window.addEventListener("online", up);
    window.addEventListener("offline", down);
    return () => {
      window.removeEventListener("online", up);
      window.removeEventListener("offline", down);
    };
  }, []);
  return online;
}

export function useDrafts() {
  const [drafts, setDrafts] = useState([]);
  const [pending, setPending] = useState(0);

  useEffect(() => {
    let cancelled = false;
    const refresh = async () => {
      const [all, count] = await Promise.all([listDrafts(), pendingCount()]);
      if (!cancelled) {
        setDrafts(all);
        setPending(count);
      }
    };
    refresh();
    const unsub = onChange(refresh);
    return () => {
      cancelled = true;
      unsub();
    };
  }, []);

  return { drafts, pending, sync: syncDrafts };
}
